import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function PageHeader({ title, subtitle, action, breadcrumbs }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ mb: { xs: 2, md: 3 } }}>
      {breadcrumbs && (
        <Breadcrumbs separator={<NavigateNext sx={{ fontSize: 14 }} />} sx={{ mb: 1, '& .MuiBreadcrumbs-li': { fontSize: 12 } }}>
          {breadcrumbs.map((b, i) =>
            i < breadcrumbs.length - 1 ? (
              <Link key={i} component="button" variant="body2" color="text.secondary"
                underline="hover" onClick={() => navigate(b.path)}
                sx={{ cursor: 'pointer', fontSize: 12 }}>
                {b.label}
              </Link>
            ) : (
              <Typography key={i} variant="body2" color="text.primary" sx={{ fontSize: 12, fontWeight: 600 }}>
                {b.label}
              </Typography>
            )
          )}
        </Breadcrumbs>
      )}
      <Box sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 1.5,
      }}>
        <Box>
          <Typography
            sx={{
              fontSize: { xs: '1.25rem', md: '1.5rem' },
              fontWeight: 700,
              letterSpacing: '-0.4px',
              color: 'text.primary',
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0.4, fontSize: { xs: 12, md: 13.5 } }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
    </Box>
  );
}
